const location = window.location;
const isLocal = location.href.indexOf('localhost') > -1;
const dir = location.pathname.substring(0, location.pathname.lastIndexOf('/'));

let url = location.origin;
if (!location.origin) {
  // Some browsers (mainly IE) does not have this property, so we need to build it manually...
  location.origin =
    location.protocol +
    '//' +
    location.hostname +
    (location.port ? ':' + location.port : '');
}

// Determine API server URL based on environment
if (isLocal) {
  // Local development: client on :3000, server on :8005
  url = url.replace('3000', '8005');
} else {
  // Production environment: use runtime-injected API server URL
  const apiServerUrl =
    window.APP_CONFIG?.API_SERVER_URL || process.env.REACT_APP_API_SERVER_URL;
  if (apiServerUrl && apiServerUrl !== '${API_SERVER_URL}') {
    // Use runtime config if available and not a template placeholder
    url = apiServerUrl;
  } else {
    // Fallback to same origin with directory path (legacy behavior)
    if (dir && dir.length > 0) {
      url += dir;
    }
  }
}

export default {
  hostURL: url,
  defaultValue: {
    requestTimeout: 1000 * 30
  },
  DropdownMenuOptions: [
    { value: 10 },
    { value: 15 },
    { value: 20 },
    { value: 50 }
  ],
  get defaultPageSize() {
    // Dynamically get the maximum value from DropdownMenuOptions
    return Math.max(...this.DropdownMenuOptions.map(opt => opt.value));
  },
  // Auto-created default preference name (hidden from user)
  AUTO_DEFAULT_PREFERENCE_NAME: '__AutoDefault__',
  ProductType: {
    catsync: '62318c17a51ff2ec2bdae2eb',
    catedge: '62723b97ccb49515e409a0f6',
    catexport: '62318c69a51ff2ec2bdae2ec',
    catviewer: '62318b42a51ff2ec2bdae2ea',
    catendo: '62318b42a51ff2ec2bdae2ed',
    catrfid: '62318b42a51ff2ec2bdae2ef'
  },
  MomentFormat: {
    DateTimeFormat: 'YYYY-MM-DDTHH:mm:ss',
    DateTimeFormatAMPM: 'DD-MM-YYYY  hh:mm A',
    TimeFormat: 'HH:mm:ss',
    Date: 'YYYY-MM-DD',
    MonthDateYear: 'MM/DD/YYYY'
  },
  ResponseCode: {
    InternalServerError: 500,
    ServerOverload: 503,
    ServerUnavailable: 403,
    SessionExpire: 401,
    BadRequest: 400,
    RequestTimeout: 408,
    Success: 200
  },
  REGEX: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#/$%/^&/*])(?=.{8,20})',
  AccountStatus: {
    Locked: 1,
    Unlocked: 0
  },
  UserRoleId: {
    SuperAdmin: '5f88184dfaeb084c680a2f4d',
    Viewer: '5f881858faeb084c680a2f4f',
    Specialist: '5f881854faeb084c680a2f4e'
  },
  GENERATE_LICENSE: 'Generate License',
  CAT_EXPORT: 'catexport',
  SUPER_ADMIN: 'superadmin',
  SPECIALIST: 'specialist',
  REPORTER: 'reporter',
  VIEWER: 'viewer',
  CAT_VIEWER: 'catviewer',
  Active: 1,
  Inactive: false,
  FakePassword: '*******',
  ProConnect: '5f88227dfaeb084c680a2f59',
  SyncMQTT: '5f882285faeb084c680a2f5a',
  UCB: '5f882270faeb084c680a2f57',
  LicActive: '5f882239faeb084c680a2f53',
  isEquipmentListDisable: '5f882369faeb084c680a2f69',
  IsDefault: true,
  IsActive: '5f882239faeb084c680a2f53',
  prePopulateData: [
    {
      EquipmentModel: '62a315684db40e3ff4c70c68',
      EquipmentType: '5f8822e4faeb084c680a2f60',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c69',
      EquipmentType: '5f8822e4faeb084c680a2f60',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c6a',
      EquipmentType: '5f8822e4faeb084c680a2f60',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c6b',
      EquipmentType: '5f8822e4faeb084c680a2f60',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c6c',
      EquipmentType: '5f8822d5faeb084c680a2f5f',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c6d',
      EquipmentType: '5f8822d5faeb084c680a2f5f',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c6e',
      EquipmentType: '5f8822d5faeb084c680a2f5f',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c6f',
      EquipmentType: '5f8822d5faeb084c680a2f5f',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c70',
      EquipmentType: '5f8822e4faeb084c680a2f60',
      ConnectivityType: ['5f882276faeb084c680a2f58'],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c71',
      EquipmentType: '5f8822e4faeb084c680a2f60',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c72',
      EquipmentType: '5f8822bbfaeb084c680a2f5d',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '624bed3478918b192cc64570',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c73',
      EquipmentType: '5f8822bbfaeb084c680a2f5d',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '624bed3478918b192cc64570',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c74',
      EquipmentType: '5f8822bbfaeb084c680a2f5d',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '624bed3478918b192cc64570',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c75',
      EquipmentType: '5f8822bbfaeb084c680a2f5d',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '624bed3478918b192cc64570',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c76',
      EquipmentType: '5f8822bbfaeb084c680a2f5d',
      ConnectivityType: [
        '5f88227dfaeb084c680a2f59',
        '624bed3478918b192cc64570',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c77',
      EquipmentType: '5f8822bbfaeb084c680a2f5d',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f88233afaeb084c680a2f65'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c78',
      EquipmentType: '5f8822bbfaeb084c680a2f5d',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f88233afaeb084c680a2f65'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c79',
      EquipmentType: '5f8822bbfaeb084c680a2f5d',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f88233afaeb084c680a2f65'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c7a',
      EquipmentType: '5f8822bbfaeb084c680a2f5d',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f88233afaeb084c680a2f65'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c7b',
      EquipmentType: '5f8822bbfaeb084c680a2f5d',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f88233afaeb084c680a2f65'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c7c',
      EquipmentType: '5f882301faeb084c680a2f63',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f88233afaeb084c680a2f65'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c7d',
      EquipmentType: '5f8822c2faeb084c680a2f5e',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f88233afaeb084c680a2f65'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c7e',
      EquipmentType: '5f8822c2faeb084c680a2f5e',
      ConnectivityType: [
        '5f88226cfaeb084c680a2f56',
        '5f882270faeb084c680a2f57'
      ],
      IsTransferPDF: '5f88233afaeb084c680a2f65'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c7f',
      EquipmentType: '624be10ecf3660efbd6eb186',
      ConnectivityType: ['5f882285faeb084c680a2f5a'],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c80',
      EquipmentType: '5f8822f1faeb084c680a2f61',
      ConnectivityType: ['5f882285faeb084c680a2f5a'],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c81',
      EquipmentType: '5f8822f8faeb084c680a2f62',
      ConnectivityType: ['5f882291faeb084c680a2f5b'],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c82',
      EquipmentType: '5f8822f8faeb084c680a2f62',
      ConnectivityType: ['5f882291faeb084c680a2f5b'],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c83',
      EquipmentType: '5f8822f8faeb084c680a2f62',
      ConnectivityType: ['5f882291faeb084c680a2f5b'],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c84',
      EquipmentType: '624be0f2cf3660efbd6eb185',
      ConnectivityType: ['624bed3478918b192cc6456e'],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c85',
      EquipmentType: '5f8822f1faeb084c680a2f61',
      ConnectivityType: ['624bed3478918b192cc6456e'],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    },
    {
      EquipmentModel: '62a315684db40e3ff4c70c86',
      EquipmentType: '5f8822f8faeb084c680a2f62',
      ConnectivityType: ['5f882285faeb084c680a2f5a'],
      IsTransferPDF: '5f882340faeb084c680a2f66'
    }
  ],
  reportFormatOptions: [
    { value: 'PDF', label: 'PDF' },
    { value: 'Excel', label: 'EXCEL' }
    // { value: 'CSV', label: 'CSV' }
  ],
  ReportFormats: {
    PDF: 'pdf',
    EXCEL: 'excel',
    CSV: 'csv'
  },
  Reports: {
    CLOCS: '62c563861d2a7c2fac5d90a2', // Complete list of current sites
    CLOCSWE: '62c563861d2a7c2fac5d90a3', // Complete list of current sites with equipment
    LBR: '62c563861d2a7c2fac5d90a4', // License by region
    NLOLM: '62c563861d2a7c2fac5d90a5', // New Licenses over last month
    WGL: '62c563861d2a7c2fac5d90a6', // Who generated licenses
    LE30: '62c563861d2a7c2fac5d90a7', // License expiring (30 days)
    LE60: '62c563861d2a7c2fac5d90a8', // License expiring (60 days)
    LE90: '62c563861d2a7c2fac5d90a9', // License expiring (90 days)
    LE: '62c563861d2a7c2fac5d90aa', // Licenses expired
    LWGP: '62c563861d2a7c2fac5d90ab', // License within Grace period
    LWHS: '62c563861d2a7c2fac5d90ac', // License within Hard stop
    ABPM: '62c563861d2a7c2fac5d90ad', // Account by product model
    BCT: '62c563861d2a7c2fac5d90ae', // By connectivity type
    BTOE: '62c563861d2a7c2fac5d90af', // By type of equipment (output serial number)
    BSR: '62c563861d2a7c2fac5d90b0', // By Site report - from license screen
    LBI: '62c563861d2a7c2fac5d90b1', // License By IDN
    BD: '62c563861d2a7c2fac5d90b2', // By Dealer
    LWEO: '62c563861d2a7c2fac5d90b3', // License with expiration of
    LBTS: '687a883f1f0c6d0b730378c8' // License by Tracking System
  },
  ConnectivityType: {
    PlugAndPlay: '6123c4f779f0fa4c6ccab572',
    Kodiak: '6123c4f779f0fa4c6ccab573',
    None: '6123c4f779f0fa4c6ccab574',
    Proconnect: '6123c4f779f0fa4c6ccab575',
    CATSync: '6123c4f779f0fa4c6ccab576',
    Directory: '6123c4f779f0fa4c6ccab579',
    AMSCO600EU: '6123c4f779f0fa4c6ccab577',
    CSVConvert: '6123c4f779f0fa4c6ccab578',
    Advantage: '61f4122c056dc61044d087c9',
    EndoCabinet: '61f41216056dc61044d087c8'
  },
  EquipmentType: {
    Incubator: '612743ffc148926e3c177acc'
  },
  EquipmentFamily: {
    NonStreamSteris: '621f20b649af30a72e014303',
    NonSterisHP: '621f20b649af30a72e01430a'
  },
  defaultPassword: 'steris@CAT',
  LicenseTypeMappings: {
    Client: 'Client',
    Core: 'Core'
  },
  Version4Id: '62597d8fec95ff1d50fecac4',
  Version5Id: '62597d8fec95ff1d50fecac5',
  allowedIdsForLicenseType: [
    '68a382dd277ad814861e222c',
    '69006598533623dc36d19043'
  ],
  routesRegex: {
    licenseDetail: /^#\/licenseDetail\/\w+/,
    trackingSystem: /^#\/trackingSystem\/\w+/
  },
  newString: 'new'
};
